/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 21/11/2013
 * Time: 19:05
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
    factory('Payment', [function (){

        var  Payment = function (resource)
        {
            this.type=null;
            this.price = null;
            this.date = null;
            this.giftItem=null;
            this.check = false;
            this._giftItemId=null;
            this.otherPaymentType=null;
            this._otherPaymentTypeId=null;
            this.checkDeposit=null;
            this._checkDepositId=null;
            if (resource!==undefined && resource!=null)
            {
                this.type =  resource.type;
                this.price = resource.price;
                this.date = new Date(resource.date);
                this.check = resource.check;
                this._giftItemId =  resource.giftItemId;
                this._otherPaymentTypeId =  resource.otherPaymentTypeId;
                this._checkDepositId =  resource.checkDepositId;
            }

        }
        Payment.prototype.getObjectResource = function()
        {
            var paymentRes = {};
            paymentRes.type = this.type;
            paymentRes.price = this.price;
            paymentRes.date = this.date;
            paymentRes.check = this.check;
            if (this.giftItem)
                paymentRes.giftItemId = this.giftItem.id;
            if (this.otherPaymentType)
                paymentRes.otherPaymentTypeId = this.otherPaymentType.id;
            if (this.checkDeposit)
                paymentRes.checkDepositId = this.checkDeposit.id;

            return paymentRes;
        };
        return  Payment;
    }]);



// WEBPACK FOOTER //
// ./js/services/models/Payment.js